export default __webpack_public_path__ + "static/media/030-volcano.36fe0993.svg";